/**
 * Formats schedule name consistently across the suppression UI
 * @param {Object} schedule - Schedule object with schedule_name, schedule_type, and frequency
 * @returns {string} - Formatted schedule name
 */
export const formatScheduleName = (schedule) => {
  if (!schedule) return "N/A";

  let displayName = schedule.schedule_name;

  // If schedule_name is null, format schedule_type
  if (!displayName) {
    const scheduleType = schedule.schedule_type;
    if (scheduleType === "recurring") {
      displayName = "Recurring";
    } else if (scheduleType === "on_demand") {
      displayName = "On Demand";
    } else {
      displayName = scheduleType || "N/A";
    }
  } else {
    // Check if it's a WAFR schedule
    if (displayName.includes("WAFR") || displayName.includes("wafr")) {
      displayName = "Well Architected Framework Review";
    }
  }

  return displayName;
};

/**
 * Gets frequency value for badge display (capitalized)
 * @param {Object} schedule - Schedule object with frequency
 * @returns {string|null} - Capitalized frequency or null if not applicable
 */
export const getFrequencyBadgeValue = (schedule) => {
  if (!schedule || schedule.schedule_type !== "recurring") {
    return null;
  }

  const frequency = schedule.frequency;
  if (frequency && ["daily", "weekly", "monthly", "hourly"].includes(frequency.toLowerCase())) {
    // Capitalize first letter
    return frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase();
  }

  return null;
};

export const getSuppressionAccountLabels = (isAzure) => ({
  noun: isAzure ? "Subscription" : "Account",
  all: isAzure ? "All Subscriptions" : "All Accounts",
  numberHeader: isAzure ? "Subscription ID" : "Account Number",
});

